export const formatCompanyName = inputString => {
  if (!inputString) {
    return "";
  }
  inputString = inputString.toLowerCase();
  inputString = inputString
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  inputString = inputString.replace("Tnhh", "TNHH");
  inputString = inputString.replace("Công Ty", "Cty");
  return inputString;
};

export const toShortName = name => {
  if (!name) {
    return "P";
  }
  const words = name.split(" ").filter(w => w.length > 1);
  if (words.length > 1) {
    return (
      words[words.length - 2][0].toUpperCase() +
      words[words.length - 1][0].toUpperCase()
    );
  } else if (words.length === 1) {
    return (
      words[0][0].toUpperCase() + words[0][words[0].length - 1].toUpperCase()
    );
  }
  return "P";
};

export const convertNumberToWords = (
  num,
  currency = "",
  isAdjust = false,
  decimalSeparator = "PHẨY" // mặc định là 'PHẨY'
) => {
  const units = [
    "",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín"
  ];
  const scales = ["", "nghìn", "triệu", "tỷ"];
  const decimalSepName = decimalSeparator === "," ? "PHẨY" : "CHẤM";

  function readTriple(number, isFull = false) {
    const hundred = Math.floor(number / 100);
    const ten = Math.floor((number % 100) / 10);
    const unit = number % 10;
    let result = "";

    // if (hundred > 0) {
    //   result += `${units[hundred]} trăm`;
    //   if (ten === 0 && unit > 0) result += " lẻ";
    // }

    if (hundred > 0) {
      result += `${units[hundred]} trăm`;
      if (ten === 0 && unit > 0) result += " lẻ";
    } else if (isFull && (ten > 0 || unit > 0)) {
      result += `không trăm`;
      if (ten === 0 && unit > 0) result += " lẻ";
    }

    if (ten > 1) {
      result += ` ${units[ten]} mươi`;
      if (unit === 1) {
        result += " mốt";
      } else if (unit === 5) {
        result += " lăm";
      } else if (unit > 0) {
        result += ` ${units[unit]}`;
      }
    } else if (ten === 1) {
      result += " mười";
      if (unit === 5) {
        result += " lăm";
      } else if (unit > 0) {
        result += ` ${units[unit]}`;
      }
    } else if (ten === 0 && unit > 0) {
      result += ` ${units[unit]}`;
    }

    return result.trim();
  }

  function splitNumber(number) {
    const parts = [];
    while (number > 0) {
      parts.push(number % 1000);
      number = Math.floor(number / 1000);
    }
    return parts.reverse();
  }

  const absNum = Math.abs(num);
  const [intStr, decimalStr] = absNum.toString().split(".");
  const intNum = parseInt(intStr, 10);
  const intParts = splitNumber(intNum);

  let result = "";

  for (let i = 0; i < intParts.length; i++) {
    const part = intParts[i];
    const scale = scales[intParts.length - 1 - i];
    const hasLowerPart = intParts.slice(i + 1).some(p => p > 0);

    if (part > 0) {
      result += `${readTriple(part, i > 0)} ${scale} `;
    } else if (hasLowerPart) {
      // Nếu nhóm này bằng 0 mà vẫn còn phần bên phải thì thêm “không trăm”
      result += `không trăm ${scale} `;
    }
  }

  if (decimalStr && parseInt(decimalStr, 10) !== 0) {
    result = `${result.trim()} ${decimalSepName.toLowerCase()}`;
    for (const digit of decimalStr) {
      const n = parseInt(digit, 10);
      result += ` ${units[n]}`;
    }
  }

  result = result.trim();

  if (isAdjust) {
    if (num > 0) result = `ĐIỀU CHỈNH TĂNG ${result}`;
    else if (num < 0) result = `ĐIỀU CHỈNH GIẢM ${result}`;
  }

  if (result === "") result = "không";

  result = result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();

  return `${result} ${currency}`.trim();
};

export function capitalizeFirstLetter(str) {
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default {
  capitalizeFirstLetter,
  convertNumberToWords,
  formatCompanyName,
  toShortName
};



// WEBPACK FOOTER //
// ./src/utils/text.js